<template>
  <div style="background-color: #fff;">
    <EducationHeader />
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjrc-kyzlzp.jpg" />
        </div>
      </a-carousel>
    </div>
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)" />
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            科研助理招聘
          </div>
        </div> -->
        <div class="recruitmentContentBox">
          <div class="recruitmentSmallBox">
            <div class="recruitmentSmallInfo" v-for="(item, index) in dataSource" :key="index"
              @click="goDetail(item.companyCode)">
              <div class="recruitmentBottomBox">
                <div class="recruitmentBottomTopBox">
                  <img v-if="item.companyLogo" :src="getImg(item.companyLogo)" alt="">
                  <img v-else src="@/assets/img/defaultImg.png" alt="">
                </div>
                <div class="recruitmentBottomMiddleBox">{{ item.companyName }}
                  <div class="recruitmentBottomRightBottom"></div>
                </div>
                <div class="recruitmentBottomBottomBox">
                  <dict-render :dict-obj="dictObjs['businessScope']" v-if="item.businessScope"
                    :text="item.businessScope"></dict-render> | <dict-render :dict-obj="dictObjs['projecttype']"
                    v-if="item.companyProperty" :text="item.companyProperty"></dict-render> | {{ item.registerMoney }}元
                </div>
              </div>
              <div class="recruitmentBottomBoxBtn" @click="goDetail(item.companyCode)">
                <a-button class="btn" type="primary">申请职位</a-button>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <div class="pagination">
          <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
        </div>
      </div>
    </div>
      <layout-footer/>
  </div>
</template>
<script>
import { getDistMixin, listMixin, dictMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import FilterInfo from '@/components/other/FilterInfo';
import { homeEducationInfo } from "@/api/educationService";
import { file_service } from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2.vue";

export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin, dictMixin],
  components: {LayoutFooter, EducationHeader, FilterInfo, DictRender },
  data() {
    return {
      dictNames: 'businessScope,projecttype',
      title: '',
      queryParam: { professionalTitle: '' },
      listUrl: homeEducationInfo.jobPageList,
      current: 1,
      pageSize: 16,
    }
  },
  created() {
    this.getDist('projecttype')
    this.getDist('businessscope')
    this.title = this.$route.query.type
  },
  mounted() {
  },
  computed: {
    getFilterInfo() {
      let list = []
      let obj = {}
      let obj1 = {}
      let obj2 = {}
      let obj3 = {}
      obj1['所属行业'] = this.projecttypeArr
      obj['search'] = 'companyProperty'
      obj2['arr'] = obj1
      obj3 = Object.assign(obj, obj2)
      list.push(obj3)


      let type = {}
      let type1 = {}
      let type2 = {}
      let type3 = {}
      type1['单位类型'] = this.businessscopeArr
      type['search'] = 'businessscope'
      type2['arr'] = type1
      type3 = Object.assign(type, type2)
      list.push(type3)
      return list
    }
  },
  methods: {
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    goDetail(id) {
      this.$router.push({
        path: '/educationService/components/recruitmentDetail',
        query: { type: '科研助理招聘', id: id }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.listBigBox {
  width: 1200px;
  margin: 10px auto;

  .industrialBox {
    width: 1200px;
    margin: 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .recruitmentContentBox {
      padding: 14px 0;
      width: 100%;

      .recruitmentSmallBox {
        padding: 12px 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .recruitmentSmallInfo {
          width: 23%;
          border: 1px solid #dedede;
          cursor: pointer;
          margin: 0 12px 15px 12px;

          .recruitmentBottomBox {
            overflow: hidden;
            padding: 10px 12px 0 12px;
            width: 100%;
            color: #333;
            font-size: 14px;
            text-align: center;

            .recruitmentBottomTopBox {
              width: 44px;
              height: 44px;
              margin: 10px auto;
              border: 1px solid #dedede;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .recruitmentBottomMiddleBox {
              padding: 12px 0;
            }

            .recruitmentBottomBottomBox {
              padding: 8px 0;
              color: #999;
              min-height: 58px;
            }
          }

          .recruitmentBottomBoxBtn {
            width: 100px;
            height: 30px;
            margin: 15px auto 20px auto;

            .btn {
              width: 100%;
              height: 100%;
            }
          }
        }

        .recruitmentSmallInfo:hover {
          border: none;
          -webkit-transition: all 0.3s ease 0s;
          transition: all 0.3s ease 0s;
          //border: 1px solid #ffffff;
          cursor: pointer;
          -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
          box-shadow: 0 5px 10px 1px #d2e6ff;
        }
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>
